import React from "react";
import { observer } from "mobx-react";
import { EsignatureConfigCreateStore } from "../../store";
import { EsignatureConfigCreateForm } from "./EsignatureConfigCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { EsignatureProvider } from "../../../../api/graphql";

export type EsignatureConfigCreateProps = {
  esignatureConfigCreateStore: EsignatureConfigCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EsignatureConfigCreate: React.FC<EsignatureConfigCreateProps> =
  observer(
    ({ esignatureConfigCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={esignatureConfigCreateStore.isSaving} />
          <EsignatureConfigCreateForm
            esignatureConfigCreateStore={esignatureConfigCreateStore}
            providerError={esignatureConfigCreateStore.errors.provider?.message}
            providerOptions={esignatureConfigCreateStore.getProviderOptions()}
            onProviderChange={(value: EsignatureProvider) => {
              esignatureConfigCreateStore.setProviderValue(value);
            }}
            provider={esignatureConfigCreateStore.entityValues.provider}
            credentialsError={
              esignatureConfigCreateStore.errors.credentials?.message
            }
            onCredentialsChange={(value: string) => {
              esignatureConfigCreateStore.setCredentialsValue(value);
            }}
            credentials={esignatureConfigCreateStore.entityValues.credentials}
            sandboxModeError={
              esignatureConfigCreateStore.errors.sandboxMode?.message
            }
            onSandboxModeChange={(value: boolean) => {
              esignatureConfigCreateStore.setSandboxModeValue(value);
            }}
            sandboxMode={esignatureConfigCreateStore.entityValues.sandboxMode}
            webhookSecretError={
              esignatureConfigCreateStore.errors.webhookSecret?.message
            }
            onWebhookSecretChange={(value: string) => {
              esignatureConfigCreateStore.setWebhookSecretValue(value);
            }}
            webhookSecret={
              esignatureConfigCreateStore.entityValues.webhookSecret
            }
            enabledError={esignatureConfigCreateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              esignatureConfigCreateStore.setEnabledValue(value);
            }}
            enabled={esignatureConfigCreateStore.entityValues.enabled}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={esignatureConfigCreateStore.isProcessing}
            onSave={() => esignatureConfigCreateStore.saveNewEsignatureConfig()}
            onCancel={() =>
              esignatureConfigCreateStore.cancelNewEsignatureConfig()
            }
          />
          <ErrorDialog
            open={esignatureConfigCreateStore.errorDialogOpened}
            title={esignatureConfigCreateStore.errorTitle}
            description={esignatureConfigCreateStore.errorDescription}
            onClose={() => esignatureConfigCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
